// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2.50001 9L20.5 9L20.5 5H10.362L7.36205 2.5H0V21H20L24 11L4 11L0 21L2.50001 9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-open-1-filled')
export default class FolderOpen1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-open-1-filled',
    }
  }
}
